const actions = {
  START_FETCH_BOOKINGS: 'rent/START_FETCH_BOOKINGS',
  END_FETCH_BOOKINGS: 'rent/END_FETCH_BOOKINGS',
  START_FETCH_RENTS: 'rent/START_FETCH_RENTS',
  END_FETCH_RENTS: 'rent/END_FETCH_RENTS',
  SET_BOOKINGS: 'rent/SET_BOOKINGS',
  SET_RENTS: 'rent/SET_RENTS'
};

export default actions;